import React from "react";
import Index from "../../Index";
import PagesIndex from "../../../container/PagesIndex";

const AfterSumitFormModal = (props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
  };
  return (
    <Index.Modal
      open={props.openModalAfterSubmit}
      onClose={(_, reason) => {
        if (reason === "backdropClick") return; // Prevent closing when clicking outside
        props.handleCloseAftereSubmitModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modal-delete modal"
    >
      <Index.Box
        sx={style}
        className="delete-modal-inner-main modal-inner"
        onClick={(e) => e.stopPropagation()} // Prevent closing on inside click
      >
        <Index.Typography
          className="delete-modal-para common-para"
          component="p"
          variant="p"
        >
          {props?.saveVale == true
            ? "Your application is NOT SUBMITTED, its saved as DRAFT (તમારી અરજી સબમિટ કરવામાં આવી નથી, તેને ડ્રાફ્ટ ગણવામાં આવે છે)"
            : "Please wait, your Sahay application submission is being processed..."}
        </Index.Typography>
      </Index.Box>
    </Index.Modal>
  );
};

export default AfterSumitFormModal;
